import { getUserTeamList, getLastTeamDetail, createTeam } from '@/api/myAccount/teamGroup/index.js';
export default ({
  name: 'SingleronTeamList',
  components: {

  },
  data() {
    return {
      groupList: [],
      groupListCopy: [],
      searchGroup: '',
      lastTeamDetail: {
        name: '',
        id: '',
      },
      dialogVisible: false,
      groupName: '',
    };
  },



  async mounted() {
    this.lastTeamDetail = { 
      name: this.$store.state.user.teamName,
      id: this.$store.state.user.teamId,
    };
  },

  methods:{
    async getTeamList() {
      try {
        const server = await getUserTeamList();
        this.groupList = server.data.map((item) => {
          return {
            id: item.id,
            name: item.name,
            memberCount: item.memberCount,
            memberLimit: item.memberLimit,
            isSelected: this.lastTeamDetail.id === item.id,
          };
        });
        this.groupListCopy = [...this.groupList];
      } catch (error) {
        this.$message.error(error);
      }
    },

    /**
     * 筛选团队列表
     */
    filterGroup() {
      if (this.searchGroup) {
        this.groupList = this.groupListCopy.filter((group) => {
          return group.name.toLowerCase().includes(this.searchGroup.toLowerCase());
        });
      } else {
        this.groupList = [...this.groupListCopy];
      }
    },

    createGroup() {
      this.dialogVisible = true;
    },

    cancelSave() {
      this.dialogVisible = false;
      this.groupName = '';
    },

    /**
     * 保存新建团队名称
     */
    async saveGroupName() {
      if (this.groupName.length > 15) {
        this.$message.error(this.$t('Group.Name.Length.Error'));
        return;
      }
      const data = {
        name: this.groupName,
      };
      createTeam(data, () => {
        this.dialogVisible = false;
        this.getTeamList();
      }, (error) => {
        this.$message.error(error);
      });
    },

    /**
     * 打开团队设置
     */
    openGroupSettings() {
      this.$router.push({ name: 'GroupSettings' });
    },

    async changeGroup(group) {
      const params = {
        teamId: group.id,
      };
      try {
        await getLastTeamDetail(params);
        window.location.reload();
      } catch (error) {
        this.$message.error(error);
        
      }
    },
  },
});